import { Headers as Headers$1 } from 'whatwg-fetch';
import qs from 'querystring';
import uuid from 'uuid';
import { Logger } from '@cvent/nucleus-logging';

if (!global.Headers && Headers$1) {
  global.Headers = Headers$1;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var httpLogPageLoadId = uuid.v4();

var HTTP_REQUEST_ID = 'HttpLogRequestId';
var HTTP_PAGE_ID = 'HttpLogPageLoadId';
/**
 * Builder class for fetch api Request objects.
 * See https://developer.mozilla.org/en-US/docs/Web/API/Request/Request
 */

var RequestBuilder = /*#__PURE__*/function () {
  function RequestBuilder(requestOptions) {
    _classCallCheck(this, RequestBuilder);

    var requestHeaders = requestOptions.headers ? new Headers(requestOptions.headers) : new Headers();

    if (!requestHeaders.has(HTTP_PAGE_ID)) {
      // allow user code to provide there own pageload id if they want.
      requestHeaders.set(HTTP_PAGE_ID, httpLogPageLoadId);
    }

    this.requestOptions = Object.assign({}, requestOptions, {
      headers: requestHeaders
    });
  }
  /* sets credentials to allow */


  _createClass(RequestBuilder, [{
    key: "withCookies",
    value: function withCookies() {
      // we're doing everything via CORS now so there is no use case for 'same-origin'
      return new RequestBuilder(Object.assign({}, this.requestOptions, {
        credentials: 'include'
      }));
    }
  }, {
    key: "withNoCache",
    value: function withNoCache() {
      // in order to avoid caching, passing `no-cache` avoids calls from being cached in the browser
      return new RequestBuilder(Object.assign({}, this.requestOptions, {
        cache: 'no-cache'
      }));
    }
    /* Return a builder with a url set to url */

  }, {
    key: "url",
    value: function url(_url) {
      return new RequestBuilder(Object.assign({}, this.requestOptions, {
        url: _url
      }));
    }
    /* Return a builder with the HTTP method for request set to POST */

  }, {
    key: "post",
    value: function post() {
      return this.method('POST');
    }
    /* Return a builder with the HTTP method for request set to GET */

  }, {
    key: "get",
    value: function get() {
      return this.method('GET');
    }
    /* Return a builder with the HTTP method for request set to PUT */

  }, {
    key: "put",
    value: function put() {
      return this.method('PUT');
    }
    /* Return a builder with the HTTP method for request set to DELETE */

  }, {
    key: "delete",
    value: function _delete() {
      return this.method('DELETE');
    }
    /* Return a builder with the HTTP method for request set to OPTIONS */

  }, {
    key: "options",
    value: function options() {
      return this.method('OPTIONS');
    }
    /* Return a builder with the HTTP method for request built by the builder. */

  }, {
    key: "method",
    value: function method(_method) {
      return new RequestBuilder(Object.assign({}, this.requestOptions, {
        method: _method
      }));
    }
    /** Return a builder with the auth token set the Autorization header **/

  }, {
    key: "auth",
    value: function auth(token) {
      return this.header('Authorization', token);
    }
    /** Return a builder with the csrf token set the X-Cvent-CSRF header **/

  }, {
    key: "csrf",
    value: function csrf(csrfToken) {
      return this.header('X-Cvent-CSRF', csrfToken);
    } // TODO  consider adding path param function.

    /**
     * Return a builder with the query param. If the param value is an array the
     * param will appear for each value in the array.
     */

  }, {
    key: "query",
    value: function query(param, value) {
      var url = this.requestOptions.url;
      var base = url.split('?')[0];
      var search = qs.parse(url.split('?')[1]);
      search[param] = value;
      return this.url("".concat(base, "?").concat(qs.stringify(search)));
    }
    /* Return a builder with the json string of value set as the request body */

  }, {
    key: "json",
    value: function json(value) {
      var body = JSON.stringify(value);
      return this.header('Content-Type', 'application/json').body(body);
    }
    /* Return a builder with a set request body */

  }, {
    key: "body",
    value: function body(value) {
      return new RequestBuilder(Object.assign({}, this.requestOptions, {
        body: value
      }));
    }
    /* Return a builder with a header set to value */

  }, {
    key: "header",
    value: function header(_header, value) {
      var headers = this.requestOptions.headers ? new Headers(this.requestOptions.headers) : new Headers();
      headers.set(_header, value);
      return new RequestBuilder(Object.assign({}, this.requestOptions, {
        headers: headers
      }));
    }
    /* Build a fetch Request object */
    // https://developer.mozilla.org/en-US/docs/Web/API/Request

  }, {
    key: "build",
    value: function build() {
      var url = this.requestOptions.url;
      var requestHeaders = this.requestOptions.headers ? new Headers(this.requestOptions.headers) : new Headers();

      if (!requestHeaders.has(HTTP_REQUEST_ID)) {
        requestHeaders.set(HTTP_REQUEST_ID, uuid.v4());
      }

      var request = new Request(url, Object.assign({}, this.requestOptions, {
        headers: requestHeaders
      }));
      return request;
    }
  }]);

  return RequestBuilder;
}();

/**
 * Calculate the delay considering the maximum delay and the option to introduce random jitter
 *
 * This implementation is "full jitter" strategy that always computes a new random delay between 0 and the computed exponential backoff
 * https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter/
 *
 * @param backoffDelay - maximum amount of time in ms for the backoff delay
 * @param jitter - whether to randomly select a delay between 0 and the maxDelay
 **/
function delayStrategy(backoffDelay, jitter) {
  var delay = jitter ? Math.random() * backoffDelay : backoffDelay;

  if (delay < 0) {
    delay = 0;
  }

  return delay;
}

var LOG = new Logger('RequestBuilder');

var pause = function pause(milliseconds) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      return resolve();
    }, milliseconds);
  });
};
/**
 * Wrapper for the fetch api that takes additional options around how to deal with
 * server too busy conditions
 * @param request - The fetch request created from the RequestBuilder.
 * @param options.initialDelay - number of milliseconds to wait if the 1st call is a retry status
 * @param options.multiplicationFactor - exponential back off
 * @param options.maxDelay - longest time to delay in milliseconds before just returning a response.
 * @param options.retryStatuses - response statuses to retry, defaults to [429]
 * @param options.jitter - whether to add random jitter to the retry backoff delay, defaults to true
 **/


function fetchAndRetryIfServerBusy(request) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$initialDelay = options.initialDelay,
      initialDelay = _options$initialDelay === void 0 ? 1000 : _options$initialDelay,
      multiplactionFactor = options.multiplactionFactor,
      multiplicationFactor = options.multiplicationFactor,
      _options$maxDelay = options.maxDelay,
      maxDelay = _options$maxDelay === void 0 ? 64000 : _options$maxDelay,
      _options$retryStatuse = options.retryStatuses,
      retryStatuses = _options$retryStatuse === void 0 ? [429] : _options$retryStatuse,
      _options$jitter = options.jitter,
      jitter = _options$jitter === void 0 ? true : _options$jitter;
  var exponentialBackoffFactor = multiplicationFactor || multiplactionFactor || 2;
  var delay = initialDelay;

  function checkAndFetch() {
    return fetch(request).then(function (response) {
      if (delay > maxDelay || !retryStatuses.includes(response.status)) {
        return response;
      }

      var iterationDelay = delayStrategy(delay, jitter);
      LOG.warn("server was busy, retrying again in ".concat(iterationDelay, " MS. { url: ").concat(request.url, ", method: ").concat(request.method, "}"));
      var newResponse = pause(iterationDelay).then(checkAndFetch);
      delay = delay * exponentialBackoffFactor;
      return newResponse;
    });
  }

  return checkAndFetch().then(function (response) {
    if (retryStatuses.includes(response.status)) {
      LOG.warn("max retries reached, giving up. ".concat(delay, " MS. { url: ").concat(request.url, ", method: ").concat(request.method, "}"));
    }

    return response;
  });
}

/**
 * A custom error class to be used with fetch
 */
function FetchError(message, response) {
  var instance = new Error(message);
  Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
  Object.defineProperty(instance, 'response', {
    value: response
  });
  return instance;
}
FetchError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true
  }
});
Object.setPrototypeOf(FetchError, Error);

/**
 * Error handler callback
 * @callback errorHandler
 * @param {Response} response - see https://developer.mozilla.org/en-US/docs/Web/API/Response
 */

/**
 * A custom fetch wrapper that enables additional behaviors based on the options passed in
 *
 * Sample usage (with default values):
 * <pre>
 * const fetch = fetchWithOptions({
 *   errorHandler: response => {
 *     throw new FetchError(response.statusText, response);
 *   },
 *   retry: {
 *     initialDelay: 1000,
 *     multiplicationFactor: 2,
 *     maxDelay: 5000,
 *     retryStatuses: [429, 502, 503]
 *   }
 * });
 * </pre>
 *
 * @param {Object} options
 * @param {errorHandler} options.errorHandler - function to call when the response is not successful (status code >= 300)
 *                                              defaults to throwing {@link FetchError}
 * @param {Object} options.retry - retry fetch request, use same retry options as {@link fetchAndRetryIfServerBusy}
 */

function fetchWithOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$errorHandler = _ref.errorHandler,
      errorHandler = _ref$errorHandler === void 0 ? function (response) {
    throw new FetchError(response.statusText, response);
  } : _ref$errorHandler,
      _ref$retry = _ref.retry;

  _ref$retry = _ref$retry === void 0 ? {} : _ref$retry;
  var _ref$retry$initialDel = _ref$retry.initialDelay,
      initialDelay = _ref$retry$initialDel === void 0 ? 1000 : _ref$retry$initialDel,
      _ref$retry$multiplica = _ref$retry.multiplicationFactor,
      multiplicationFactor = _ref$retry$multiplica === void 0 ? 2 : _ref$retry$multiplica,
      _ref$retry$maxDelay = _ref$retry.maxDelay,
      maxDelay = _ref$retry$maxDelay === void 0 ? 5000 : _ref$retry$maxDelay,
      _ref$retry$retryStatu = _ref$retry.retryStatuses,
      retryStatuses = _ref$retry$retryStatu === void 0 ? [429, 502, 503] : _ref$retry$retryStatu,
      _ref$retry$jitter = _ref$retry.jitter,
      jitter = _ref$retry$jitter === void 0 ? true : _ref$retry$jitter;
  return function (request) {
    var response = fetchAndRetryIfServerBusy(request, {
      initialDelay: initialDelay,
      multiplicationFactor: multiplicationFactor,
      maxDelay: maxDelay,
      retryStatuses: retryStatuses,
      jitter: jitter
    });
    return response.then(function (res) {
      if (!res.ok) {
        errorHandler(res);
      }

      return res;
    });
  };
}

export { RequestBuilder, httpLogPageLoadId, fetchAndRetryIfServerBusy, fetchWithOptions, FetchError, delayStrategy };
//# sourceMappingURL=index.js.map
